import { render } from "./SetupChallenge.vue?vue&type=template&id=6a331a27"
import script from "./SetupChallenge.vue?vue&type=script&lang=ts"
export * from "./SetupChallenge.vue?vue&type=script&lang=ts"
script.render = render

export default script